import { colors } from '../../OpportunityWorkspace.style';

export const dividerBase = {
    width: '100%',
    height: 1,
    backgroundColor: colors.sectionDivider,
};
